<template>
  <div class="success-wrapper">
    <div class="iconfont icon-chenggong"></div>
    <div class="success1">恭喜您, 预约成功</div>
    <div class="success2">请提前10分钟上线准备</div>
    <div class="content-wrapper">
      <div class="item-wrapper">
        <div class="title">预约医生:</div>
        <div class="text">{{ obj.realname }}&nbsp;{{ obj.jobName }}</div>
      </div>
      <div  class="item-wrapper">
        <div class="title">预约时间:</div>
        <div class="text">{{ _getWeekDay(obj.week) }}&nbsp;{{ obj.time }}&nbsp;{{ obj.startTime }}</div>
      </div>
    </div>
    <div class="download-btn" @click="onDownloadClick">查看预约</div>
  </div>
</template>

<script>
import { getOrderInfo } from '@/api/yuyueApi'

let orderId = ''
export default {
  components: {},
  props: {},
  data () {
    return {
      obj: {}
    }
  },
  watch: {},
  computed: {},
  methods: {
    onDownloadClick () {
      this.$router.replace({
        path: '/orderlist'
      })
      // window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ivyvi.patient'
    },
    async getInfo () {
      const params = {
        orderId
      }
      const res = await getOrderInfo(params)
      this.obj = res.obj
    },
    _getWeekDay (num) {
      const weeks = {
        1: '周日',
        2: '周一',
        3: '周二',
        4: '周三',
        5: '周四',
        6: '周五',
        7: '周六'
      }
      return weeks[parseInt(num)]
    }
  },
  created () {
    orderId = this.$route.query.orderId
    this.getInfo()
  },
  mounted () { }
}
</script>
<style lang="stylus" scoped>

.success-wrapper {
  color white
  font-size 18px
  padding-top 30px
  display flex
  flex-direction column
  align-items center
  .icon-chenggong {
    color #f67264
  }
  .success1 {
    color #f67264
    font-size 25px
    margin-top 20px
  }
  .success2 {
    margin-top 20px
  }
  .content-wrapper {
    margin-top 50px
    .item-wrapper {
      line-height 30px
      display flex
      .title {
        padding-right 5px
      }
    }
  }
}
.download-btn {
  color #4a4a4a
  width 300px
  height 60px
  margin 0 auto
  margin-top 50px
  background-color #fbf144
  border-radius 30px
  font-size 25px
  line-height 60px
  text-align center
  //animation free_download 0.5s linear alternate infinite
}
@keyframes free_download {
  0% {
    transform scale(0.9)
  }
  100% {
    transform scale(1)
  }
}
</style>
